import styled from 'styled-components/native';

import {
  neutralGrey,
  neutralLight,
  warrior,
  white,
} from '../../../constants/color';

export const containerMarginTop = 20;

export const S = {
  Container: styled.View`
    margin-top: ${containerMarginTop}px;
  `,
  ListHeaderContainer: styled.View`
    align-items: center;
    background-color: ${white};
    flex-direction: row;
    padding: 12px 15px;
    margin-bottom: 5px;
    shadow-color: ${neutralGrey};
    shadow-offset: 0 2px;
    shadow-opacity: 0.4;
    shadow-radius: 2px;
  `,
  ListHeaderTitle: styled.Text`
    color: ${warrior};
    font-size: 15px;
    margin-left: 5px;
  `,
  Separator: styled.View`
    border-top-width: 1px;
    border-style: solid;
    border-color: ${neutralLight};
    flex: 1 auto;
    margin: 0 15px;
    max-height: 1px;
    min-height: 1px;
    padding: 0;
  `,
  ShippedContainer: styled.View``,
  UnshippedContainer: styled.View``,
  SectionHeaderTitle: styled.Text`
    margin: 20px 15px 10px;
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
    color: ${warrior};
  `,
};
